import { connect } from 'react-redux'
import NewAllowanceComponent from '../../components/expenses/newAllowance.component'
import {
  saveAllowance,
  closeExpenseSnackBar,
  saveAllowanceUpdate,
  cancelAllowanceUpdate,
  loadAllowanceCost,
  clearAdditionalVehicleInfo,
  priceChange,
  editAndGoToInvoice,
  getUserCompanyUpdateInfo
} from '../../actions/index'
import { createVehicleItems } from '../../utils/invoice.utils'

const mapStateToProps = (state) => {
  const vehicleTypeList = [
    { type: 'default_vehicle_type', fi: 'Valitse', en: 'Select', est: 'Vali' },
    { type: 'own_car', fi: 'Oma auto', en: 'Own Car', est: 'Isiklik auto' },
    {
      type: 'motor_boat_max_50hp',
      fi: 'Moottorivene, enintään 50hv',
      en: 'Motorboat, up to 50 hp',
      est: 'Mootorpaat, kuni 50 hj'
    },
    {
      type: 'motor_boat_over_50hp',
      fi: 'Moottorivene, yli 50hv',
      en: 'Motorboat, over 50 hp',
      est: 'Mootorpaat, üle 50 hj'
    },
    {
      type: 'snowmobile',
      fi: 'Moottorikelkka',
      en: 'Snowmobile',
      est: 'Mootorsaan'
    },
    { type: 'rover', fi: 'Mönkijä', en: 'Quad bike', est: 'ATV' },
    {
      type: 'motorcycle',
      fi: 'Moottoripyörä',
      en: 'Motorcycle',
      est: 'Mootorratas'
    },
    { type: 'moped', fi: 'Mopo', en: 'Moped', est: 'Mopeed' },
    { type: 'bicycle', fi: 'Polkupyörä', en: 'Bicycle', est: 'Jalgratas' }
  ]

  const additionalVehicleList = [
    {
      type: 'default_additional_vehicle_cost',
      fi: 'Valitse',
      en: 'Select',
      est: 'Vali'
    },
    { type: 'trailer', fi: 'Perävaunu', en: 'Trailer', est: 'Haagis' },
    { type: 'caravan', fi: 'Asuntovaunu', en: 'Caravan', est: 'Haagissuvila' },
    {
      type: 'cabin',
      fi: 'Iso asuntovaunu',
      en: 'Big caravan',
      est: 'Suur haagissuvila'
    }
  ]
  const countryList = state.expense.allowanceCost
    ? state.expense.allowanceCost.full_time_allowance.full_time_allowance
    : []
  const listPerLang = (listName) => {
    let selectedLang
    if (state.language.lang == undefined) {
      selectedLang = 'fi'
    } else {
      selectedLang = state.language.lang
    }
    if (selectedLang === 'fi') {
      switch (listName) {
        case vehicleTypeList:
          return vehicleTypeList.map((el) =>
            Object.assign({ type: el.type, value: el.fi })
          )
        case additionalVehicleList:
          return additionalVehicleList.map((el) =>
            Object.assign({ type: el.type, value: el.fi })
          )
        default:
          return listName
      }
    } else if (selectedLang === 'en') {
      switch (listName) {
        case vehicleTypeList:
          return vehicleTypeList.map((el) =>
            Object.assign({ type: el.type, value: el.en })
          )
        case additionalVehicleList:
          return additionalVehicleList.map((el) =>
            Object.assign({ type: el.type, value: el.en })
          )
        default:
          return listName
      }
    } else if (selectedLang === 'est') {
      switch (listName) {
        case vehicleTypeList:
          return vehicleTypeList.map((el) =>
            Object.assign({ type: el.type, value: el.est })
          )
        case additionalVehicleList:
          return additionalVehicleList.map((el) =>
            Object.assign({ type: el.type, value: el.est })
          )
        default:
          return listName
      }
    }
  }

  const vehicleTypeItems = createVehicleItems(listPerLang(vehicleTypeList))
  const vehicleAdditionalItems = createVehicleItems(
    listPerLang(additionalVehicleList)
  )

  // KAS-349 Taking the year cost at start date when edit the allowance
  const start_date = state.expense.isEdit
    ? state.expense.allowanceEdit[0].start_date
    : new Date()

  return {
    start_date: start_date,
    isEdit: state.expense.isEdit,
    id:
      state.expense.allowanceEdit &&
      state.expense.allowanceEdit[0] &&
      state.expense.allowanceEdit[0].id,
    user: state.oidc.user,
    allowanceCost: state.expense.allowanceCost,
    showSpinner: state.expense.showSpinner,
    showSnackbar: state.expense.showSnackbar,
    showFailSnackbar: state.expense.showFailSnackbar,
    countryList: countryList,
    vehicleTypeItems: vehicleTypeItems,
    vehicleAdditionalItems: vehicleAdditionalItems,
    language: state.language.lang,
    enable_allowance_back_btn: state.invoice.enable_allowance_back_btn,
    invoiceFormValues: state.invoice.invoiceFormValues,
    errMessage: state.expense.errMessage,
    location: state.router.location.pathname,
    allowanceEdit: state.expense.allowanceEdit
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
    loadAllowanceCost: (year) => dispatch(loadAllowanceCost(year)),
    saveAllowance: (formValues) => dispatch(saveAllowance(formValues)),
    closeSnackbar: () => dispatch(closeExpenseSnackBar()),
    saveAllowanceUpdate: (formValues) =>
      dispatch(saveAllowanceUpdate(formValues)),
    cancelAllowanceUpdate: () => dispatch(cancelAllowanceUpdate()),
    clearAdditionalVehicleInfo: () => dispatch(clearAdditionalVehicleInfo()),
    priceChange: (price) => dispatch(priceChange(price)),
    editAndGoToInvoice: (formValues) =>
      dispatch(editAndGoToInvoice(formValues)),
    getUserCompanyUpdateInfo: () => dispatch(getUserCompanyUpdateInfo())
  }
}

const mergeProps = (stateProps, dispatchProps, ownProps) =>
  Object.assign({}, stateProps, dispatchProps, ownProps)

const newAllowanceContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(NewAllowanceComponent)

export default newAllowanceContainer
